import {UserAgent} from "./UserAgent";

export class ScrollBar {
    static enable(timeOut = 0){
        if (!UserAgent.deviceOS()){
            let body = document.body;
            setTimeout(() => {
                body.style.overflow = '';
                body.style.marginRight = '';
            }, timeOut);
        }
    }

    static disable(timeOut = 0){
        if (!UserAgent.deviceOS()){
            let body = document.body;

            setTimeout(() => {
                body.style.overflow = 'hidden';
                body.style.marginRight = '15px';
            }, timeOut);
        }else {
            let body = document.body;

            setTimeout(() => {
                body.style.overflow = '';
            }, timeOut);
        }
    }
}